import { NotFound } from "@components/error"
import { useNotifications } from "@components/notification"
import { useGetFestivalDefaultContextQuery } from "@graphql/apollo"
import type { GetFestivalDefaultContextQuery } from "@graphql/types"
import { createContext, type ReactNode, useEffect } from "react"

/**
 * All the festival locale/brand related code below is a temporary way to handle locale information
 * and should be removed in the future, ideally, it should be handled from user preferences
 */
type FestivalContext = {
	locale: NonNullable<GetFestivalDefaultContextQuery["festivalDefaultLocale"]>
	brand: NonNullable<GetFestivalDefaultContextQuery["festivalDefaultBrand"]>
}

export const FestivalContext = createContext<FestivalContext | undefined>(undefined)

export const FestivalContextProvider = ({ children }: { children: ReactNode }) => {
	const { notify } = useNotifications()
	const { data, loading, error } = useGetFestivalDefaultContextQuery()

	useEffect(() => {
		if (error) {
			notify("error", "Failed to fetch festival default context")
		}
	}, [error, notify])

	const locale = data?.festivalDefaultLocale
	const brand = data?.festivalDefaultBrand

	if (loading) return null
	if (!(locale && brand)) return <NotFound />

	return <FestivalContext.Provider value={{ locale, brand }}>{children}</FestivalContext.Provider>
}
